import { checkAllCasesHandled } from "trader.ts/utils";
import { formulaColor } from "../parsing_from_ur";

export type colors = {
  primary: string;
  lighter: string;
  darker: string;
  text: string;
  verylight?: string;
};

export const primaryGreyPlanningColors: colors = {
  primary: "var(--grey-900)",
  lighter: "var(--grey-700)",
  darker: "var(--grey-900)",
  text: "var(--grey-100)",
};

export const bluePlanningColors: colors = {
  primary: "#4c8ef3",
  lighter: "#74a1e6",
  darker: "#55729e",
  text: "white",
};
export const greyPlanningColors: colors = {
  primary: "darkgrey",
  lighter: "#c1c1c1",
  darker: "#969696",
  text: "black",
  verylight: "#fafafa",
};
export const paleBlue: colors = {
  primary: "#c1d9ff",
  lighter: "#e2eeff",
  darker: "#9cc5ff",
  text: "black",
};
export const whitePlanningColors: colors = {
  primary: "#ececec",
  lighter: "#e8e5e5",
  darker: "#c1bebe",
  text: "black",
};
export const pinkPlanningColors = {
  primary: "#f34da9",
  lighter: "#f978bf",
  verylight: "#fce7f3",
  darker: "#9e577e",
  text: "white",
};
export const green = {
  primary: "#088c55",
  lighter: "#06b16a",
  verylight: "#dcfce7",
  darker: "#045031",
  text: "white",
};
export const purple = {
  primary: "#5412ff",
  lighter: "#936afa",
  verylight: "#f1ebff",
  darker: "#6a53a2",
  text: "white",
};
export const orange = {
  primary: "#f39100",
  lighter: "#f3ab42",
  verylight: "#fef3c7",
  darker: "#c37500",
  text: "white",
};
export const red = {
  primary: "#fd3b3b",
  lighter: "#ff6c6f",
  darker: "#7f3c3c",
  text: "white",
};

export function formulaColorToPlanningColors(fc: formulaColor): colors {
  if (fc === "Pink") {
    return pinkPlanningColors;
  } else if (fc === "Purple") {
    return purple;
  } else if (fc === "Green") {
    return green;
  } else if (fc === "Orange") {
    return orange;
  } else if (fc === "Red") {
    return red;
  } else {
    return checkAllCasesHandled(fc);
  }
}

export function makeGradient(c: colors | [colors, colors]): string {
  if (Array.isArray(c)) {
    return `linear-gradient(135deg, ${c[0].primary} 49.5%, black 50%, ${c[1].primary} 50.5%)`;
  } else {
    return `linear-gradient(135deg, ${c.primary} 0%, ${c.lighter} 100%)`;
  }
}
